// extracted by mini-css-extract-plugin
module.exports = {"success_text":"success-text_success_text__WzRzn"};